import React, { useContext } from "react";
import InputsContext from "../contexts/InputsContext";
import { findInputs } from "../concerns/findInputs";
import DatePicker from "../../../inputs/DatePicker";

const DatePickerStep = ({ stepIndex }) => {
  const { inputs, setInputs } = useContext(InputsContext);
  const thisStepInput = findInputs(inputs, stepIndex);

  const stepIsValid = (value) => {
    thisStepInput.valid = value;
    setInputs({ ...inputs });
  };

  return (
    <div
      className={`${inputs.currentIndex === stepIndex ? "block" : "hidden"}`}
    >
      <div className="text-4xl font-bold mb-10">
        {thisStepInput.inputs[0].label}
      </div>

      <DatePicker model={inputs.model} stepIsValid={stepIsValid} />
    </div>
  );
};

export default DatePickerStep;
